app.service('savedStoresService', [
  '$http',
  function ($http) {
    const removeStore = ({ userId, type, locationCode }) =>
      $http({
        method: 'DELETE',
        url: `/api/users/${userId}/convenience_store_pickup_infos/${type}/${locationCode}`,
      });

    return {
      removeStore,
    };
  },
]);
